import initScrollReveal from "./scripts/scrollReveal";
import initTiltEffect from "./scripts/tiltAnimation";
import { targetElements, defaultProps } from "./data/scrollRevealConfig";

initScrollReveal(targetElements, defaultProps);
initTiltEffect();

const getScreenshots = (imageElement) => {
  if (imageElement.dataset.carousel) {
    const secondaryImage = imageElement
      .closest(".thumbnail")
      ?.querySelector("img[data-carousel-secondary]");
    const secondarySrc = secondaryImage?.src;

    if (secondarySrc) {
      return [imageElement.src, secondarySrc];
    }
  }

  const screenshots = imageElement.dataset.screenshots;

  if (!screenshots) {
    return [imageElement.src];
  }

  return screenshots
    .split(",")
    .map((src) => src.trim())
    .filter(Boolean);
};

const createCarouselButton = (direction) => {
  const button = document.createElement("button");
  const isPrevious = direction === "prev";

  button.type = "button";
  button.className = `project-carousel__arrow project-carousel__arrow--${direction}`;
  button.setAttribute(
    "aria-label",
    isPrevious ? "Image precedente du projet" : "Image suivante du projet"
  );
  button.innerHTML = isPrevious ? "&lsaquo;" : "&rsaquo;";

  return button;
};

const createCarouselCounter = () => {
  const counter = document.createElement("span");
  counter.className = "project-carousel__counter";
  counter.setAttribute("aria-live", "polite");
  return counter;
};

const initProjectCarousels = () => {
  const projectImages = document.querySelectorAll(
    "#projects .project-wrapper__image img[data-carousel], #projects .project-wrapper__image img[data-screenshots]"
  );

  projectImages.forEach((imageElement) => {
    const screenshots = getScreenshots(imageElement);

    if (screenshots.length <= 1) {
      return;
    }

    const thumbnail = imageElement.closest(".thumbnail");

    if (!thumbnail) {
      return;
    }

    let currentIndex = 0;
    const counter = createCarouselCounter();

    const updateImage = () => {
      imageElement.src = screenshots[currentIndex];
      imageElement.dataset.currentSlide = String(currentIndex + 1);
      counter.textContent = `${currentIndex + 1}/${screenshots.length}`;
    };

    const previousButton = createCarouselButton("prev");
    const nextButton = createCarouselButton("next");

    previousButton.addEventListener("click", (event) => {
      event.preventDefault();
      event.stopPropagation();
      currentIndex = (currentIndex - 1 + screenshots.length) % screenshots.length;
      updateImage();
    });

    nextButton.addEventListener("click", (event) => {
      event.preventDefault();
      event.stopPropagation();
      currentIndex = (currentIndex + 1) % screenshots.length;
      updateImage();
    });

    thumbnail.addEventListener("keydown", (event) => {
      if (event.key === "ArrowLeft") {
        event.preventDefault();
        currentIndex = (currentIndex - 1 + screenshots.length) % screenshots.length;
        updateImage();
      }
      if (event.key === "ArrowRight") {
        event.preventDefault();
        currentIndex = (currentIndex + 1) % screenshots.length;
        updateImage();
      }
    });

    screenshots.forEach((src) => {
      const preloadImage = new Image();
      preloadImage.src = src;
    });

    thumbnail.classList.add("project-carousel");
    thumbnail.setAttribute("tabindex", "0");
    thumbnail.append(previousButton, nextButton, counter);
    updateImage();
  });
};

const initPrivateProjectLinks = () => {
  const privateLinks = document.querySelectorAll('a[data-private="true"]');
  const privateMessage = "Privé : pour en voir plus, me contacter.";

  privateLinks.forEach((linkElement) => {
    linkElement.classList.add("is-private");
    linkElement.removeAttribute("target");
    linkElement.setAttribute("aria-disabled", "true");
    linkElement.dataset.privateMessage =
      linkElement.dataset.privateMessage || privateMessage;
    linkElement.setAttribute("title", linkElement.dataset.privateMessage);

    linkElement.addEventListener("click", (event) => {
      event.preventDefault();
      event.stopPropagation();
    });
  });
};

initProjectCarousels();
initPrivateProjectLinks();
